import { render, staticRenderFns } from "./DescriptionCard.vue?vue&type=template&id=19a71188&scoped=true&"
import script from "./DescriptionCard.vue?vue&type=script&lang=js&"
export * from "./DescriptionCard.vue?vue&type=script&lang=js&"
import style0 from "./DescriptionCard.vue?vue&type=style&index=0&id=19a71188&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a71188",
  null
  
)

export default component.exports